import {FeatureGate} from 'common/report/constants';
import type {CurrentProject} from 'common/report/model-resources/projects';

export function hasAccessToExperimentsApp(currentProject?: CurrentProject): boolean {
  if (!currentProject) {
    return false;
  }

  return !!currentProject.getFeatureGate(FeatureGate.ExperimentsApp);
}

export function maxExperiments(currentProject?: CurrentProject): number {
  if (!currentProject) {
    return 0;
  }

  // Otherwise, return the limit from the feature gate
  return currentProject.getFeatureGate(FeatureGate.MaxExperiments) ?? -1;
}
